import { useCallback } from 'react';
import { selectRow, selectRowByRowIndex } from '@client-shared/ui-agGrid';
import { useDispatch } from 'react-redux';

const useSelectAgGridRow = <TData>({ name, fields }: {
  name: string,
  fields: string[],
}) => {
  const dispatch = useDispatch();
  const selectRowCallback = useCallback(
    (data: TData) => dispatch(selectRow({ name, fields, data })),
    [dispatch, name, fields]
  );

  const selectRowByRowIndexCallback = useCallback(
    (index: number) => dispatch(selectRowByRowIndex(index)),
    [dispatch]
  );

  return {
    selectAgGridRow: selectRowCallback,
    selectAgGridRowByIndex: selectRowByRowIndexCallback,
  };
};

export default useSelectAgGridRow;
